import { useMemo, forwardRef, useState } from 'react'
import { useWireValue } from '@forminator/react-wire'
import { user as storeUser } from '@store'
import Dropzone from 'react-dropzone'
import cn from 'clsx'

import { MdCloudUpload } from 'react-icons/md'

export const UploadFile = forwardRef(({
    id,
    className,
    dropzoneClassName,
    name = 'document',
    accept,
    onDrop,
    fieldName,
    dropZoneStyle,
    hidden,
    disabled,
    multiple = true,
    showUploadIcon = true,
    ...props
} = {}, ref) => {
    
    const [isDraggingOver, setIsDraggingOver] = useState(false)
    
    const user = useWireValue(storeUser)
    
    // A little hacky, but very useful to have full E2E tests
    const isTestUser = useMemo(() => (
        user?.email?.startsWith('parse.integration.tests') === true
    ), [user])
    
    return (
        
        <div id={id} className={className} hidden={isTestUser ? false : (hidden || false)}>
            
            <Dropzone
                ref={ref}
                onDrop={(file, rejected) => onDrop(file, rejected, fieldName)}
                accept={accept}
                multiple={multiple}
                useFsAccessApi={!isTestUser}
                onDragEnter={() => setIsDraggingOver(true)}
                onDragLeave={() => setIsDraggingOver(false)}>
                
                {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
                    
                    <div
                        className={cn('dropzone dropzone-single dz-clickable', dropzoneClassName)}
                        data-toggle="dropzone"
                        data-dropzone-url="http://"
                        {...props}>
                        <div
                            className={cn('dz-default dz-message dz-small', dropzoneClassName, {
                                'is-drag-reject': isDragActive && isDragReject,
                                'is-drag-accepted': isDragActive && !isDragReject,
                            })}
                            {...getRootProps()}
                            style={dropZoneStyle}>
                            
                            <input
                                name={name}
                                {...getInputProps()}
                                disabled={disabled !== undefined ? !disabled : false}
                                data-test-id="UploadFileDropZoneFileInput"/>
                            
                            {!showUploadIcon && (
                                isDraggingOver
                                    ? 'Drop documents here to upload'
                                    : 'Click or drag documents here to upload'
                            )}
                            
                            {showUploadIcon && (
                                <div
                                    className="absolute-centered p-12 w-4/12 max-w-96
                                        border border-accent/30
                                        rounded-xl cursor-pointer hover:bg-accent/10 text-center"
                                    onClick={() => ref.current?.open()}>
                                    {showUploadIcon && (
                                        <MdCloudUpload className={cn('mx-auto mb-4 text-9xl', {
                                            'opacity-60': !isDraggingOver,
                                            'opacity-90': isDraggingOver,
                                        })} />
                                    )}
                                    <div className="px-3 py-3">
                                        {isDraggingOver ? 'Drop' : 'Click or drag'}
                                        {' documents'}
                                        <br />
                                        {'here to upload'}
                                    </div>
                                </div>
                            )}
                        
                        </div>
                    
                    </div>
                    
                )}
            
            </Dropzone>
        
        </div>
        
    )
    
})

UploadFile.displayName = 'UploadFile'
